











import {Component, Vue} from 'vue-property-decorator';
import RotatingHeader from '@/components/Views/Booking Flow/RotatingHeader.vue';
import CancellationRequests from '@/components/Views/Dashboard/Directory/CancellationRequests.vue';
import ManualReviewRequired from '@/components/Views/Dashboard/Directory/ManualReviewRequired.vue';
import NoServiceTypesPros from '@/components/Views/Dashboard/Directory/NoServiceTypesPros.vue';
import NoImageServices from '@/components/Views/Dashboard/Directory/NoImageServices.vue';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import {Mixins} from 'vue-property-decorator';

@Component({
    components: {NoImageServices, NoServiceTypesPros, ManualReviewRequired, CancellationRequests, RotatingHeader},
})
export default class DashboardDirectory extends Mixins(UserRoleMixin) {
    public created() {
        this.redirectVendors();
    }
    public mounted() {
        this.redirectVendors();
    }
    public redirectVendors() {
        if (this.userIsVendor) {
            this.$router.replace('/dashboard/bookings');
        }
    }
}
